'use strict';

var _require = require('lodash'),
    get = _require.get;

var WORD_REGEXP = /\S+/g;

function getWordCount(text) {
  return get(text.match(WORD_REGEXP), 'length', 0);
}

module.exports = getWordCount;